/**
 * RTWO Event Bus — Base Service
 */

import { EVENT_BUS_VERSION } from '../domain-models';
import type { EBusServiceDescriptor, EBusServiceStatus, IEBusService } from '../service-interfaces';
import type { ebusInternalEventBus } from '../events/ebus-internal-event-bus';

export interface EBusServiceContext {
  eventBus: typeof ebusInternalEventBus;
}

export abstract class BaseEBusService implements IEBusService {
  abstract readonly serviceId: string;
  abstract readonly serviceName: string;
  abstract readonly description: string;
  abstract readonly integrations: string[];
  abstract readonly requiresRealEventSources: boolean;
  readonly version = EVENT_BUS_VERSION.version;

  protected status: EBusServiceStatus = 'not_initialized';

  constructor(protected readonly context: EBusServiceContext) {}

  async initialize(): Promise<void> {
    this.status = 'waiting_for_real_event_sources';
  }

  getStatus(): EBusServiceStatus {
    return this.status;
  }

  getDescriptor(): EBusServiceDescriptor {
    return {
      serviceId: this.serviceId as EBusServiceDescriptor['serviceId'],
      serviceName: this.serviceName,
      version: this.version,
      status: this.status,
      description: this.description,
      integrations: this.integrations,
      requiresRealEventSources: this.requiresRealEventSources,
    };
  }
}
